import styled, { css } from 'styled-components';

export const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  background-color: #003566;
  color: #ffffff;
  height: 72px;
  position: sticky;
  top: 0;
  z-index: 99;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);

  @media (max-width: 600px) {
    padding: 0 16px;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  @media (max-width: 600px) {
    gap: 12px;
  }
`;

export const MenuButton = styled.button<{ isOpen: boolean }>`
  background: transparent;
  border: none;
  color: #ffffff;
  cursor: pointer;
  padding: 10px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(${(props) => (props.isOpen ? '180deg' : '0deg')});
  transition: transform 0.4s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  color: #e0e6ed;
  white-space: nowrap;

  @media (max-width: 480px) {
    font-size: 1rem;
    display: none;
  }
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 28px;

  @media (max-width: 600px) {
    gap: 12px;
  }
`;

export const UserProfileContainer = styled.div`
  position: relative;
`;

export const UserProfileButton = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 30px;
  transition: background-color 0.2s ease;
  user-select: none;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  .avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: #ffffff;
    color: #0a192f;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 0.95rem;
  }

  span {
    font-weight: 500;
    font-size: 0.95rem;
    color: #ffffff;

    @media (max-width: 480px) {
      display: none;
    }
  }
`;

export const DropdownMenu = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 58px;
  right: 0;
  background-color: #ffffff;
  color: #1e1e1e;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  width: 210px;
  overflow: hidden;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  transform: translateY(${(props) => (props.isOpen ? '0' : '-10px')});
  pointer-events: ${(props) => (props.isOpen ? 'auto' : 'none')};
  transition: all 0.25s ease-in-out;
  z-index: 50;

  a {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 18px;
    text-decoration: none;
    color: #1e1e1e;
    font-size: 0.95rem;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #f1f5f9;
    }
  }
`;
export const Logo = styled.img`
  height: 50px;
  object-fit: contain;

  @media (max-width: 480px) {
    height: 50px;
  }
`;
